import styled from "styled-components";
import Colors from "../../../../Constant/Colors";
import { STYLES } from "../../../../Constant/Theme";
import { BoldHeadingPri, RegSmPri, SpaceBetween } from "../../../../Components/CustomStyles";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  /* overflow: scroll; */
  /* padding: 20px; */
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
export const PopularCourseContent = styled.div`
  width: 100%;
  min-width: 480px;
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  margin-top: 5px;
  flex-wrap: ${(props) => (props.isInstructor ? "wrap" : null)};
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  @media only screen and (max-width: 600px) {
    min-width: 100%;
  }
`;
export const CourseHeading = styled.div`
${STYLES.HorizontalAlign};
width: 60%;
margin-right: 5px; 
display: flex; 
justify-content: flex-end; 
@media only screen and (max-width: 600px) {
    display: none;
  }
`;
export const SearchDiv = styled.div`
width: 50%;
 min-width: 190px;
  max-width: 250px;
   margin-right: 10px; 
@media only screen and (max-width: 900px) {
    display: none;
  }
`;
export const PopularCourse = styled.div`
  box-sizing: border-box;
  width: 24%;
  height: 130px;
  padding: 10px 20px;
  margin: 5px;
  background-color: ${Colors.whiteThemeColor};
  border-radius: 10px;
  box-shadow: 2px 1px 10px 1px #6662;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  overflow:hidden ;
  cursor: pointer;
  /* padding:5px 10px ; */
  @media only screen and (max-width: 900px) {
    width: 24%;
    padding: 10px 10px;
    margin: 5px;
  }
`;

export const TruncatedText = styled.div`
 display: -webkit-box;
  -webkit-line-clamp: 1; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const YourCourse = styled.div`
  box-sizing: border-box;
  width: 31%;
  min-width: 120px;
  background-color: ${Colors.whiteThemeColor};
  border-radius: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  @media only screen and (max-width: 900px) {
    width: 47%;
    min-width: 40%;
    padding: 5px 10px;
    
    margin: 5px;
  }
  `;

export const EachContent = styled.div`
  width: 100px;
  height: 100px;
  margin: 10px 5px;
  /* background-color: ${Colors.red}; */
  border: 1px solid ${Colors.primary};
  border-radius: 8px;
${STYLES.VerticalAlign}
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: rgba(1, 122, 115, 0.2) ; 
  }
`;
